import { BackednResponse } from "@shared/lib/types";

import { BRIEF_SCRIPTING_QUERY_KEY } from "@entities/brief/lib/constants";
import { ToastService } from "@shared/lib/services";
import { IGetScriptingResponse } from "@shared/lib/types/briefCampains";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { BriefConfigService } from "../../services/briefConfigService";

export function useGetBriefScripting(scriptingId: string) {
  const { data, isLoading, isError, error, refetch } = useQuery<
    BackednResponse<IGetScriptingResponse>
  >({
    queryKey: BRIEF_SCRIPTING_QUERY_KEY(scriptingId),
    queryFn: () => BriefConfigService.getScripting(scriptingId),
    enabled: !!scriptingId,
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    scripting: data?.data,
    isFetching: isLoading,
    isError,
    refetch
  };
}
